import React, { useRef } from 'react';
var VeltCommentsSidebarV2MinimalActionsDropdownTrigger = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-trigger-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2MinimalActionsDropdownTrigger;
